export default "__VITE_ASSET__m7FLL0cT__"